import { render, staticRenderFns } from "./TheAppHeader.vue?vue&type=template&id=0b7888bf&scoped=true&"
import script from "./TheAppHeader.vue?vue&type=script&lang=js&"
export * from "./TheAppHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheAppHeader.vue?vue&type=style&index=0&id=0b7888bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7888bf",
  null
  
)

export default component.exports